import { datadogLogs } from '@datadog/browser-logs';
import { config } from '../config';

// CURRENT LOGGING BEHAVIOUR
// LOCAL env → console logging
// DEV and PROD env → datadog logging

const envLocation = `[${config.serviceName}]`;

interface LogContext {
    tourId?: string;
    vehicleId?: string;
    assetId?: string;
    [key: string]: unknown;
}

const logMethod = (level: 'debug' | 'info' | 'warn' | 'error', args: unknown[], context?: LogContext) => {
    if (import.meta.env.DEV) {
        (console[level] as (...args: unknown[]) => void)(envLocation, ...args, context || '');
    } else {
        const message = args.length > 0 ? `${envLocation} ${args.join(' ')}` : envLocation;
        if (context) {
            datadogLogs.logger[level](message, context);
        } else {
            datadogLogs.logger[level](message);
        }
    }
};

/* eslint-disable no-console */
export const trace = {
    debug: (...args: unknown[]) => logMethod('debug', args),
    info: (...args: unknown[]) => logMethod('info', args),
    warn: (...args: unknown[]) => logMethod('warn', args),
    error: (...args: unknown[]) => logMethod('error', args),

    // Enhanced methods with context for critical operations
    infoWithContext: (message: string, context: LogContext) => logMethod('info', [message], context),
    errorWithContext: (message: string, context: LogContext) => logMethod('error', [message], context),
    warnWithContext: (message: string, context: LogContext) => logMethod('warn', [message], context),
};
